import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { bookingInfo } from '../../booking/book.helper';
import { getISOWeek } from 'date-fns';
import { BehaviorSubject } from 'rxjs';
import { CleintService } from '../../../../../shared/services/client.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ThrowStmt } from '@angular/compiler';
import { DatePipe } from '@angular/common';
import { FormBuilder, FormGroup, FormControl, Validators, FormArray } from '@angular/forms';

@Component({
  selector: 'app-step1',
  templateUrl: './step1.component.html',
})
export class Step1Component implements OnInit {




  constructor(private fb: FormBuilder, private cleintService: CleintService, public datepipe: DatePipe, private formBuilder: FormBuilder) { }
  selected!: Date | null;
  isAppointmentsLisLoading = false;
  displayTimeSection = false;
  selectedItemsList = [];
  checkedIDs = [];
  DateTimeForm!: FormGroup;
  date = null;
  date1 = new Date();
  dateTime = null;


  @Input('updateParentModel')
  updateParentModel!: (
    part: Partial<bookingInfo>,
    isFormValid: boolean
  ) => void;
  TaratanTypeform!: FormGroup;
  @Input()
  defaultValues!: Partial<bookingInfo>;
  private unsubscribe: Subscription[] = [];
  TimeList = [];
  final_TimeList = [];
  latest_date: any;
  priceList = [];
  TimeLabel = [];


  ngOnInit() {
    this.initForm();
    this.getPrice();
    this.updateParentModel({
    }, this.checkForm());
  }




  initForm() {
    this.DateTimeForm = this.fb.group({
      date: [null, [Validators.required]],
      time: [null, [Validators.required, , Validators.maxLength(2)]],
    });

    this.DateTimeForm.get('date').setValue(this.latest_date);

    const formChangesSubscr = this.DateTimeForm.valueChanges.subscribe((val) => {
      this.updateParentModel(val, this.checkForm());
    });

    this.unsubscribe.push(formChangesSubscr);
  }


  checkForm() {
    return !this.DateTimeForm.get('date')?.hasError('required')
      && !this.DateTimeForm.get('time')?.hasError('required');
  }


  checkCheckBoxvalue(event) {
    // console.log(event);
  }

  paramsTest;
  async onChange(result: Date) {

    this.checkedIDs = [];
    this.final_TimeList = [];

    // console.log(result);
    this.isAppointmentsLisLoading = true;

    this.latest_date = this.datepipe.transform(result, 'yyyy-MM-dd');
    this.cleintService.getTimeByDayId(this.latest_date).subscribe({
      next: (response: any) => {

     var ss ={
          "success":true,
          "message":"Available Times Retrieved",
          "data":[
            {
              'id' : 1,
              "date":"2023-03-23",
              "time":"17:00:00",
              'isChecked': false
            },
            { 
              'id' : 2,
              "date":"2023-03-21", 
              "time":"18:00:00",
              'isChecked': false
            },
            { 
              'id' : 3,
              "date":"2023-03-21", 
             "time":"19:00:00",
             'isChecked': false
            },
            { 
              'id' : 4,
              "date":"2023-03-21", 
              "time":"20:00:00",
              'isChecked': false
            },{ 
              'id' : 5,
              "date":"2023-03-21", 
              "time":"23:00:00",
              'isChecked': false
            },
            { 'id' : 6,
              "date":"2023-03-21", 
            "time":"00:00:00",
            'isChecked': false
          }
          ]};
          // this.paramsTest = ss.data;
          this.paramsTest = response.data;
          

        this.isAppointmentsLisLoading = false;
        this.displayTimeSection = true;
        this.TimeList = response?.data;
        for (let i = 0; i < this.TimeList.length; i++) {
          this.final_TimeList.push({
            id: 1,
            label: this.TimeList[i],
            isChecked: false
          });

        }
        console.log(this.final_TimeList);
      },
      error: (error) => {
        this.TimeList = [];
        this.displayTimeSection = false;
        this.isAppointmentsLisLoading = false;
      }
    }
    );


  }

  getWeek(result: Date): void {
    console.log('week: ', getISOWeek(result));
  }

  params
  async getPrice() {
    this.cleintService.getPrice().subscribe({
      next: (response: any) => {
        

    

        this.priceList = response?.data;
        console.log('Price list retrieved');
        console.log(this.priceList);
      },
      error: (error) => {

        console.log(error);
      }
    }
    );
  }

  MSG;
  isDisabled = false;
  chooseagain = false;
  isLoadingTime = false;
  changeChoose() {

    this.updateParentModel({
    }, false);

    this.isDisabled = false;
    this.selectedItemsList = [];
    this.checkedIDs = [];
    this.final_TimeList = [];
    this.TimeSelectedArray = [];
    this.isLoadingTime = true;
    this.cleintService.getTimeByDayId(this.latest_date).subscribe({
      next: (response: any) => {

        this.isAppointmentsLisLoading = false;
        this.TimeList = response?.data;
        for (let i = 0; i < this.TimeList.length; i++) {
          this.final_TimeList.push({
            id: 1,
            label: this.TimeList[i],
            isChecked: false
          });

        }
        this.isLoadingTime = false;
        console.log(this.final_TimeList);
      },
      error: (error) => {
        this.isLoadingTime = false;
        this.isAppointmentsLisLoading = false;
      }
    }
    );


  }

  addHours(timeString) {
    let dt = new Date('1970-01-01T' + timeString);
    dt.setHours(dt.getHours() + 1);
    let TimeAddHour = dt.toLocaleTimeString([], { hour: "numeric", minute: "numeric", hour12: true });
    console.log(typeof TimeAddHour)
    
    return TimeAddHour ;
  }


  tConvert(timeString) {
    const timeString12hr = new Date('1970-01-01T' + timeString )
      .toLocaleTimeString([],
        { hour: 'numeric', minute: 'numeric' , hour12: true}
      );
    return timeString12hr 
  }


  changeSelection(item: any) {

    console.log("Checked:" + item.isChecked)
    if (!item.isChecked) {
      this.selectedItemsList = [];
    }
    if (this.selectedItemsList.length >= 1) {
      this.isDisabled = true;
      this.chooseagain = true;
    } else {
      this.fetchSelectedItems();
    }

    if (this.selectedItemsList.length == 0) {
      console.log("length is 0")
      this.updateParentModel({
      }, false);

    }

    console.log("this.DateTimeForm.value.time");
    console.log(this.DateTimeForm.value.time);
  }


  fetchSelectedItems() {

    console.log("fetchSelectedItems, before length is: " + this.selectedItemsList.length);
    this.selectedItemsList = this.final_TimeList.filter((value, index) => {
      return value.isChecked;
    });

    console.log("fetchSelectedItems, after length is: " + this.selectedItemsList.length);
    // console.log("Selected are: " + this.selectedItemsList[0].label)
    this.DateTimeForm.get('time').setValue(this.selectedItemsList);


  }



  fetchCheckedIDs() {
    this.checkedIDs = [];
    this.final_TimeList.forEach((value, index) => {
      if (value.isChecked) {
        this.checkedIDs.push(value.id);
      }
    });

  }

  isDisabledButton = false;
  TimeSelectedArray = []


  TimeSelected(item) {


    if (item.isChecked) {
      this.TimeSelectedArray.push(
        {
          'id': item.id, 'date': item.date, 'time': item.time
        }
        );
    }
    else {
      this.removeVal(this.TimeSelectedArray, item);
    }

    this.DateTimeForm.get('time').setValue(this.TimeSelectedArray);
  
    if (this.TimeSelectedArray.length >= 2) {
      this.isDisabled = true;
      this.chooseagain = true;
    }
    console.log(item)
  };


  removeVal(arr, val) {

    // get index of object with id of 37
const removeIndex = arr.findIndex( item => item.id === val.id );
// remove object
arr.splice( removeIndex, 1 );


    // for (var i = 0; i < arr.length; i++) {
    //   if (arr[i].id == val.id)
    //     arr.splice(i, 1);
    // }
  }



}
